// extracted by mini-css-extract-plugin
module.exports = {"profileImpact":"ProfileImpact_profileImpact__AioDK","profileImpactCards":"ProfileImpact_profileImpactCards__YsD6c"};